export async function handleResponse<T>(res: Response): Promise<T> {
    if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
            const result = await res.json()

            if (result?.redirect) {
                window.location.replace(result.redirect)
            }
        }

        let errorText: string

        const contentType = res.headers.get('content-type')

        if (contentType && contentType.includes('application/json')) {
            const body = await res.json()
            errorText = typeof body === 'string' ? body :
                body.errors.map((error: { msg: string }) => error.msg).join('\n')
        } else {
            errorText = await res.text()
        }

        throw new Error(res.status + ': ' + errorText)
    }

    let json
    try {
        json = await res.json()
    } catch (e) {
        if (e instanceof SyntaxError) {
            throw new Error(e.message)
        }
    }

    return json.data ? json.data : json
}

export const getErrorCode = (error: Error) =>
    error.message.substring(0, error.message.indexOf(":"))
